import EnumSet from 'Services/enumSet'

export interface IQuotationPaymentStatus extends EnumSet {
  none: number
  waitingPayment: number
  paid: number
  refused: number
}

const QuotationPaymentStatus = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  waitingPayment: { value: 1, description: 'Aguardando pagamento' },
  paid: { value: 2, description: 'Pago' },
  refused: { value: 3, description: 'Recusado' },
}) as IQuotationPaymentStatus

export default QuotationPaymentStatus